import React, { useEffect, useRef, useState, useCallback, useMemo } from 'react';
import "gantt-task-react/dist/index.css";
import { LuSearch, LuCalendar, LuUser, LuClock, LuAlertTriangle } from "react-icons/lu";
import { connect } from "react-redux";
import { compose } from "redux";
import { LuCircleAlert } from "react-icons/lu"
import { FiList, FiClock, FiRefreshCw, FiXCircle, FiCheckCircle } from "react-icons/fi"
//import { CSSTransition } from 'react-transition-group';
import { getDepartmentsActionData, getDepartments, getDepartmentsAction, addActionComments, editActionComments } from "../../store/actions/departmentActions";
import { editActionProgress, editAction } from "../../store/actions/riskActions";
import { getComplianceActions, getComplianceActionsData } from "../../store/actions/complianceActions"

import debounce from "lodash/debounce";
import { Disable } from 'react-disable';
import KanBanComponent from './KanBan';
import Gantt from './Gantt';
import ComplianceGantt from './ComplianceGantt'

import "./Gantt.css";

import Select from 'react-select'
import { Table, KanbanSquare, GanttChart } from "lucide-react";


import ActionOverlay from "../../components/Action/ActionOverlay";

import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    borderColor: state.isFocused ? '#3b3b3b' : '#ccc',
    boxShadow: state.isFocused ? '0 0 0 1px #3b3b3b' : 'none',
    '&:hover': {
      borderColor: '#3b3b3b',
    },
    backgroundColor: '#EEF0ED',
    padding: 1,
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 999999999999, // Ensures the menu appears above other elements
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#3b3b3b' : state.isFocused ? '#EEF0ED' : 'white',
    color: state.isSelected ? 'white' : '#3b3b3b',
    '&:hover': {
      // backgroundColor: '#EEF0ED',
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#3b3b3b',
  }),
};



const statusMeta = {
  "Not started": { cls: "bg-gray-100 text-gray-700 border-gray-200" },
  "In progress": { cls: "bg-blue-100 text-blue-700 border-blue-200" },
  "Completed": { cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  "Problem": { cls: "bg-rose-100 text-rose-700 border-rose-200" },
};

function chipCls(label) {
  const m = label && statusMeta[label];
  return `inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs border ${m ? m.cls : "bg-gray-100 text-gray-700 border-gray-200"
    }`;
}

function isCompleted(label) {
  return label === "Completed";
}

function isBehind(t) {
  try {
    if (t.styles && t.styles.backgroundColor === "#F07167") return true; // backend hint
    const start = new Date(t.start);
    const end = new Date(t.end);
    const now = new Date();
    const total = end - start;
    const elapsed = now - start;
    const frac = total > 0 ? elapsed / total : 0;
    const pct = Number(t.progress || 0);
    return pct < frac * 100 && !isCompleted(t.progressLabel);
  } catch {
    return false;
  }
}

function isOverdue(t) {
  try {
    return new Date(t.end) < new Date() && !isCompleted(t.progressLabel);
  } catch {
    return false;
  }
}

function AssigneeStack({ assignees = [], owner }) {
  const pics = [...assignees].slice(0, 3);
  return (
    <div className="flex -space-x-2 items-center">
      {pics.map((u, i) => (
        <img
          key={i}
          src={
            u.avatar ||
            "https://ui-avatars.com/api/?name=" +
            encodeURIComponent(`${u.firstName || ""} ${u.lastName || ""}`)
          }
          title={`${u.firstName || ""} ${u.lastName || ""}`}
          className="w-6 h-6 rounded-full border-2 border-white shadow"
          alt=""
        />
      ))}
      {owner && owner.id ? (
        <img
          src={
            owner.avatar ||
            "https://ui-avatars.com/api/?name=" +
            encodeURIComponent(`${owner.firstName || ""} ${owner.lastName || ""}`)
          }
          title={`Owner: ${owner.firstName || ""} ${owner.lastName || ""}`}
          className="w-6 h-6 rounded-full border-2 border-white shadow ring-1 ring-amber-400"
          alt=""
        />
      ) : null}
    </div>
  );
}


const DashboardComponent = (props) => {


  const { comp_actions, getComplianceActionsDataFN, comp_actions_stats, getComplianceActionsFN, isComp, activeComplianceId, onSelectActions, onSelectFindings, actions_stats, getDepartmentsActionDataFN, departments, getDepartmentsFN, getDepartmentsActionFN, actions, addActionCommentsFN, editActionFN, editActionCommentsFN, activeDepartmentId, profile } = props;

  ////////console.log("ACTIONS GANTT :", actions);
  // Step 1: Initialize state for input values
  const [tasks, setTasks] = useState([]);

  const [isLoading, setIsLoading] = useState(true);


  const [risk_id, setRiskId] = useState(null);
  const [isActionOpen, setIsActionOpen] = useState(false);
  const [action_id, setActionId] = useState(null);


  // const [taskDescription, setTaskDescription] = useState("");


  // eslint-disable-next-line react-hooks/exhaustive-deps


  useEffect(() => {
    if (activeDepartmentId) {
      //alert(activeDepartmentId);
      if (profile.role !== "User") {
        //console.log("1")
        getDepartmentsActionFN(activeDepartmentId);
        getDepartmentsActionDataFN(activeDepartmentId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeDepartmentId]);


  useEffect(() => {
    if (activeComplianceId && isComp) {
      //alert(activeDepartmentId);
      //console.log("Here")
      getComplianceActionsFN(activeComplianceId);
      getComplianceActionsDataFN(activeComplianceId)

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeComplianceId, isComp]);


  const [activeDepartment, setActiveDepartment] = useState(activeDepartmentId ? activeDepartmentId : null);

  useEffect(() => {

    getDepartmentsFN();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    //console.log(profile, !activeDepartmentId)

    if (profile?.department_id && (profile.role === "User") && (!activeDepartmentId)) {
      //alert(profile.department_id);
      setActiveDepartment(profile.department_id);
      ////console.log(profile.department_id)
      //console.log("Getign actions ", profile.department_id)
      getDepartmentsActionFN(profile.department_id);
      getDepartmentsActionDataFN(activeDepartmentId);
    }
    else if(profile.role ==="Admin" &&  (!activeDepartmentId)){
      getDepartmentsActionFN(0);
      getDepartmentsActionDataFN(0);

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile, activeDepartmentId]);

  useEffect(() => {


    if (activeDepartmentId) {
      setActiveDepartment(activeDepartmentId)

    }
  }, [activeDepartmentId]);

  const ganttWrapperRef = useRef(null);

  useEffect(() => {
    if (ganttWrapperRef.current) {
      // Use timeout to wait for Gantt to finish its own scroll logic
      setTimeout(() => {
        ganttWrapperRef.current.scrollLeft = 0;
      }, 100); // 100ms usually works — adjust if needed
    }
  }, [tasks]); // Runs every time tasks change

  /*
  useEffect(() => {
      if (departments?.length > 0) {
          //alert(1)
          setActiveDepartment(departments[0].department_id);
          getDepartmentsActionFN(departments[0].department_id);
          //////////console.log(departments[0].department_id, departments);
          //select first department
      }
  }, [departments]);

  */




  useEffect(() => {
    let source;
    if (isComp) {
      source = Array.isArray(comp_actions_stats) ? comp_actions_stats : comp_actions;
    } else {
      source = Array.isArray(actions_stats) ? actions_stats : actions;
    }
    ////console.log("new tasks", source)
    setTasks(normalizeTasks(source));
  }, [actions_stats, actions, isComp, comp_actions_stats, comp_actions]);


  function normalizeTasks(src) {
    const raw = Array.isArray(src) ? src : [];
    // keep only real action rows
    const onlyTasks = raw.filter(
      (t) => t && t.type === "task" && (t.iid != null || t.action_id != null)
    );
    // de-dup by iid/action_id
    const byId = new Map();
    for (const t of onlyTasks) {
      const key = t.iid ?? t.action_id ?? t.id;
      if (!byId.has(key)) byId.set(key, t);
    }
    let out = Array.from(byId.values());

    // guard: sometimes a project slips in; drop rows where name === project (if you never intend that)
    //out = out.filter((t) => t.name !== t.project);

    // optional: drop untitled
    out = out.filter((t) => (t.name || "").trim()?.length > 0);

    return out;
  }


  const closeAction = async (data, action_id) => {

    setIsActionOpen(false);
    await updateControlServerData(data, action_id);                  // wait for save
    let fresh;
     //console.log("Here?")
    if (isComp) {
      if (activeComplianceId)
        fresh = await getComplianceActionsDataFN(activeComplianceId)
    } else {
      //console.log("2", activeDepartment)
      if (activeDepartment) {
        //console.log("2")
        fresh = await getDepartmentsActionDataFN(activeDepartment); // wait for store refresh
      }
    }
    // optional: immediate local derive (no waiting for useEffect)
    if(activeComplianceId || activeDepartment)
      setTasks(normalizeTasks(Array.isArray(fresh) ? fresh : []));

   
  };

  const openAction = (action) => {
    //////console.log("action", action);
    if (!action.iid)
      return
    setActionId(action.iid);
    setRiskId(action.risk_id);
    setIsActionOpen(true);
  };




  // local UI state
  const [q, setQ] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [onlyMine, setOnlyMine] = useState(false);

  const counts = useMemo(() => {
    let open = 0,
      closed = 0;
    tasks.forEach((t) => (isCompleted(t.progressLabel) ? closed++ : open++));
    return { open, closed, total: tasks?.length };
  }, [tasks]);

  const meId = profile && profile.user_id ? Number(profile.user_id) : null;

  const filtered = useMemo(() => {
    let list = [...tasks];

    if (statusFilter !== "All") {
      list = list.filter((t) => (t.progressLabel || "Not started") === statusFilter);
    }

    if (q.trim()) {
      const L = q.toLowerCase();
      list = list.filter(
        (t) => (t.name || "").toLowerCase().includes(L) || (t.project || "").toLowerCase().includes(L)
      );
    }

    if (onlyMine && meId) {
      list = list.filter(
        (t) => (t.assignees || []).some((u) => Number(u.id) === meId) || (t.riskOwner && Number(t.riskOwner.id) === meId)
      );
    }

    // prioritize overdue/behind, then nearest due date
    list.sort((a, b) => {
      const sa = isOverdue(a) ? 2 : isBehind(a) ? 1 : 0;
      const sb = isOverdue(b) ? 2 : isBehind(b) ? 1 : 0;
      if (sa !== sb) return sb - sa;
      return new Date(a.end) - new Date(b.end);
    });

    return list;
  }, [tasks, q, statusFilter, onlyMine, meId]);


  const updateControlServerData = async (data, action_id) => {
    
    const updatedData = { ...data };
    if (updatedData.StartDate) {
      const d = new Date(updatedData.StartDate);
      d.setDate(d.getDate());
      updatedData.StartDate = d.toISOString().split("T")[0];
    }
    if (updatedData.EndDate) {
      const d = new Date(updatedData.EndDate);
      d.setDate(d.getDate());
      updatedData.EndDate = d.toISOString().split("T")[0];
    }

    setIsLoading(true);
    try {
      // IMPORTANT: await the thunk
      const saved = await editActionFN(risk_id, action_id, updatedData);
      return saved; // bubble up if you want
    } finally {
      setIsLoading(false);
    }
  };


  const handleProgressChange = (task, progress) => {
    if (!task.iid) {
      console.error("Task IID is missing.");
      return;
    }

    ////////console.log("Task being updated:", JSON.parse(JSON.stringify(task)));

    // Update the backend with the new progress value
    props.editActionProgressFN(task.iid, task.progress)
      .then((updatedAction) => {
        ////////console.log("Progress updated successfully:", updatedAction);

        // Update tasks in state to reflect the new progress
        setTasks((prevTasks) =>
          prevTasks.map((t) => (t.iid === task.iid ? { ...t, progress: task.progress } : t))
        );
      })
      .catch((error) => {
        console.error("Failed to update progress:", error);
        alert("Failed to update progress. Please try again.");
      });
  };


  const priorityChip = (p) => {
    const label = (p || "").trim();
    const base =
      "text-[10px] inline-flex items-center gap-1 px-1.5 py-0.5 rounded border font-medium";

    switch (label) {
      case "Critical":
        return (
          <span
            className={`${base} bg-red-50 border-red-200 text-red-700 font-semibold`}
          >
            Critical
          </span>
        );

      case "High":
        return (
          <span
            className={`${base} bg-red-50 border-red-200 text-red-700 font-semibold`}
          >
            High
          </span>
        );

      case "Medium":
        return (
          <span
            className={`${base} bg-orange-50 border-orange-200 text-orange-600 font-semibold`}
          >
            Medium
          </span>
        );

      case "Low":
        return (
          <span
            className={`${base} bg-yellow-50 border-yellow-200 text-yellow-600 font-medium`}
          >
            Low
          </span>
        );

      default:
        return null;
    }
  };


  function ActionStatCard({ label, value }) {
    // icons: feather
    // import { FiList, FiClock, FiRefreshCw, FiXCircle, FiCheckCircle } from "react-icons/fi";
    let Icon = null;
    let iconColor = '';

    switch (label) {
      case 'Total Actions':
        Icon = FiList;
        iconColor = 'text-gray-400';
        break;
      case 'Open Actions':
        Icon = FiClock;
        iconColor = 'text-blue-500';
        break;
      case 'In Progress':
        Icon = FiRefreshCw;
        iconColor = 'text-amber-500';
        break;
      case 'Problem':
        Icon = FiXCircle;
        iconColor = 'text-rose-500';
        break;
      case 'Completed':
        Icon = FiCheckCircle;
        iconColor = 'text-green-500';
        break;
      default:
        Icon = null;
    }

    return (
      <div className="rounded-xl border border-gray-200 bg-white p-4 flex flex-col justify-between">
        <div className="flex items-center justify-between">
          <div className="text-xs text-gray-500">{label}</div>
          {Icon && <Icon className={`w-4 h-4 ${iconColor}`} />}
        </div>
        <div className="mt-1 text-2xl font-normal text-[#0E0E0E]">{value}</div>
      </div>
    );
  }

  const [currView, setCurrView] = useState("Table");

  const handleViewChange = async (page) => {
    ////console.log(page)
    setCurrView(page)
  };


  const [countsA, setCountsA] = useState({
    total: 0,
    open: 0,
    inProgress: 0,
    problem: 0,
    completed: 0
  });

  useEffect(() => {
    if (!Array.isArray(actions_stats)) return;

    const next = actions_stats.reduce(
      (acc, a) => {
        const pl = (a.progressLabel || a.status || '').toLowerCase().trim();
        acc.total += 1;
        if (pl === 'completed') acc.completed += 1;
        else if (pl === 'in progress') acc.inProgress += 1;
        else if (pl === 'problem') acc.problem += 1;
        else if (pl === 'open' || pl === 'not started' || pl === '') acc.open += 1;
        else acc.open += 1;
        return acc;
      },
      { total: 0, open: 0, inProgress: 0, problem: 0, completed: 0 }
    );

    setCountsA(next);
  }, [actions_stats]);


  const [pageIndex, setPageIndex] = useState(0);
  const pageSize = 5;

  const totalPages = Math.max(1, Math.ceil(filtered?.length / pageSize));
  const canPreviousPage = pageIndex > 0;
  const canNextPage = pageIndex < totalPages - 1;

  const gotoPage = (i) => setPageIndex(Math.min(Math.max(i, 0), totalPages - 1));
  const previousPage = () => canPreviousPage && setPageIndex((p) => p - 1);
  const nextPage = () => canNextPage && setPageIndex((p) => p + 1);

  // reset/clamp when filters change or results shrink
  useEffect(() => { setPageIndex(0); }, [q, statusFilter]); // add others if you enable them
  useEffect(() => {
    if (pageIndex > totalPages - 1) setPageIndex(Math.max(0, totalPages - 1));
  }, [totalPages, pageIndex]);

  // slice after filtering
  const paged = useMemo(() => {
    const start = pageIndex * pageSize;
    return filtered.slice(start, start + pageSize);
  }, [filtered, pageIndex, pageSize]);

  return (
    <div className="w-full bg-[#F8F8F8] min-h-[100dvh] overflow-y-auto">
      {/* Fixed-width page container */}
      <div className="px-6 md:px-10 xl:px-16 2xl:px-24 pt-8 md:pt-5 pb-16">
        {/* Header row: title + subtitle + tabs */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 md:gap-4 mb-6">
          <div>
            <h1 className="text-xl md:text-2xl font-medium tracking-wide text-[#0E0E0E]">
              Actions
            </h1>
            <p className="text-xs md:text-sm text-gray-600">
              Track and manage security actions across your organization
            </p>
          </div>

          <div className="flex items-center gap-2">
            {/* Findings tab */}
            <button
              onClick={onSelectFindings}
              className={`
              flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg transition
              bg-white text-gray-700 hover:bg-gray-100
            `}
            >
              <svg
                className="w-4 h-4"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M4 6h16M4 12h16M4 18h16" strokeLinecap="round" />
              </svg>
              <span>Findings</span>
            </button>

            {/* Actions tab */}
            <button
              onClick={onSelectActions}
              className={`
              flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg transition
              bg-[#0F0F19] text-white
            `}
            >
              <svg
                className="w-4 h-4"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  d="M5 13l4 4L19 7"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>Actions</span>
            </button>
          </div>
        </div>

        <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {/* <ActionStatCard label="Total Actions" value={countsA.total} /> */}
          <ActionStatCard label="Open Actions" value={countsA.open} />
          <ActionStatCard label="In Progress" value={countsA.inProgress} />
          <ActionStatCard label="Problem" value={countsA.problem} />
          <ActionStatCard label="Completed" value={countsA.completed} />
        </div>

        {/* Filters Wrapper (Actions) */}
        <div className="mt-6 mb-3 bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
          <div className="flex flex-wrap items-center gap-2">
            {/* Search */}
            <div className="relative flex-1 min-w-[260px]">
              <input
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="Search actions…"
                className="
      w-full
      bg-[#F3F4F6]
      rounded-md
      text-sm
      pl-8 pr-3 py-1.5
      border-none
      focus:outline-none
      focus:ring-0
    "
              />

              <svg
                className="absolute left-2 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>


            {/* Status Filter */}
            <div className="relative">
              <svg
                className="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M3 5h18l-7 8v4l-4 2v-6L3 5z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                className="
      appearance-none
      bg-[#F3F4F6]
      rounded-md
      text-sm
      pl-8 pr-6 py-2
      border-none
      focus:outline-none
      focus:ring-0
    "
              >
                <option>All</option>
                <option>Not started</option>
                <option>In progress</option>
                <option>Problem</option>
                <option>Completed</option>
              </select>

              <svg
                className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-500"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" />
              </svg>
            </div>


            {/* View Selector – 3 buttons instead of dropdown */}
            <div className="flex items-center gap-2 ml-auto">
              {/* Table */}
              <button
                type="button"
                onClick={() => handleViewChange?.("Table")}
                className={`
      flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-medium transition
      ${currView === "Table"
                    ? "bg-[#0F0F19] text-white"
                    : "bg-[#F3F4F6] text-gray-700 hover:bg-gray-200"}
    `}
              >
                <Table className="w-4 h-4" />
                <span>Table</span>
              </button>

              {/* Kanban */}
              <button
                type="button"
                onClick={() => handleViewChange?.("Kanban")}
                className={`
      flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-medium transition
      ${currView === "Kanban"
                    ? "bg-[#0F0F19] text-white"
                    : "bg-[#F3F4F6] text-gray-700 hover:bg-gray-200"}
    `}
              >
                <KanbanSquare className="w-4 h-4" />
                <span>Kanban</span>
              </button>

              {/* Gantt */}
              <button
                type="button"
                onClick={() => handleViewChange?.("Gantt")}
                className={`
      flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-medium transition
      ${currView === "Gantt"
                    ? "bg-[#0F0F19] text-white"
                    : "bg-[#F3F4F6] text-gray-700 hover:bg-gray-200"}
    `}
              >
                <GanttChart className="w-4 h-4" />
                <span>Gantt</span>
              </button>
            </div>
          </div>
        </div>



        {/* Content by currView */}
        {currView === "Table" ? (
          <>
            {/* Actions Table – single clean card, same design as Findings */}
            <div className="mt-6 shadow-xl rounded-2xl bg-white border border-gray-300 w-full">
              {/* Inner padding */}
              <div className="p-4">
                {/* Table container (header + rows in one rounded box) */}
                <div className="border border-gray-200 rounded-xl overflow-hidden">
                  {/* Header */}
                  <div className="grid grid-cols-[140px_18px_1fr_120px_160px_130px_130px_130px] gap-4 px-4 py-3 bg-white text-xs font-semibold text-gray-700 border-b border-gray-200">
                    <div className="-ml-1">Action ID</div>
                    <div></div>
                    <div className="-ml-1">Title</div>
                    <div className="text-left">Priority</div>
                    <div className="text-left">Status</div>
                    <div className="-ml-1">Due</div>
                    <div className="text-left">Progress</div>
                    <div>Owners</div>
                  </div>

                  {/* Rows */}
                  <div className="divide-y divide-gray-200">
                    {paged?.length > 0 ? (
                      paged.map((t) => {
                        const overdue = isOverdue(t);
                        const behind = isBehind(t);
                        const pct = Math.max(
                          0,
                          Math.min(100, Math.round(t.progress || 0))
                        );

                        // New formatted Action ID: CNT-{currentYear}-{iid padded}
                        const currentYear = new Date().getFullYear();
                        const rawIid = t.iid ?? t.id ?? 0;
                        const formattedActionId = `CNT-${currentYear}-${String(
                          rawIid
                        )
                          .toString()
                          .padStart(3, "0")}`;

                        return (
                          <button
                            key={t.id}
                            className="w-full text-left transition-colors duration-200 hover:bg-gray-50 focus:bg-gray-50"
                            onClick={() => openAction(t)}
                          >
                            <div className="grid grid-cols-[140px_18px_1fr_120px_160px_130px_130px_130px] gap-4 items-center px-4 py-4">
                              {/* Action ID */}
                              <div className="text-sm font-medium text-gray-700 -ml-1">
                                {formattedActionId}
                              </div>

                              {/* (reserved empty col – e.g. for icons/checkbox later) */}
                              <div></div>

                              {/* Title + chips + description */}
                              <div className="min-w-0 -ml-1">
                                {/* Row 1: title + chips */}
                                <div className="flex items-center gap-2">
                                  <span className="text-sm text-gray-700 font-normal line-clamp-1">
                                    {t.name}
                                  </span>

                                  {behind && (
                                    <span className="ml-1 text-[10px] inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-rose-50 text-rose-700 border border-rose-200">
                                      <LuCircleAlert className="w-3 h-3" /> behind
                                    </span>
                                  )}
                                  {overdue && (
                                    <span className="ml-1 text-[10px] inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-amber-50 text-amber-700 border border-amber-200">
                                      <LuClock className="w-3 h-3" /> overdue
                                    </span>
                                  )}
                                </div>

                                {/* Row 2: description (2 lines max) */}
                                {t.action_description && (
                                  <p
                                    className="mt-0.5 text-xs text-gray-500 overflow-hidden"
                                    style={{
                                      display: "-webkit-box",
                                      WebkitLineClamp: 2,
                                      WebkitBoxOrient: "vertical",
                                    }}
                                  >
                                    {t.action_description}
                                  </p>
                                )}
                              </div>

                              {/* Priority */}
                              <div className="flex justify-left">
                                {priorityChip(t.priority)}
                              </div>

                              {/* Status */}
                              <div className="text-left">
                                <span className={chipCls(t.portClass || t.progressLabel)}>
                                  {t.progressLabel || "Not started"}
                                </span>
                              </div>

                              {/* Due */}
                              <div className="text-sm text-gray-700 flex items-center gap-1 justify-start -ml-1">
                                <LuCalendar className="w-4 h-4 text-gray-400" />
                                {t.end ? new Date(t.end).toLocaleDateString() : "-"}
                              </div>

                              {/* Progress (moved before Owners) */}
                              <div className="text-right">
                                <div className="text-sm font-medium text-gray-800">
                                  {pct}%
                                </div>
                                <div className="w-full h-1.5 bg-gray-200 rounded overflow-hidden mt-1">
                                  <div
                                    className={`h-1.5 ${isCompleted(t.progressLabel)
                                      ? "bg-emerald-500"
                                      : behind
                                        ? "bg-rose-500"
                                        : "bg-blue-500"
                                      }`}
                                    style={{ width: `${pct}%` }}
                                  />
                                </div>
                              </div>

                              {/* Owners (after Progress now) */}
                              <div>
                                <AssigneeStack assignees={t.assignees} />
                              </div>
                            </div>
                          </button>
                        );
                      })
                    ) : (
                      <div className="px-4 py-16 text-center text-gray-500 text-sm">
                        No actions match your filters.
                      </div>
                    )}
                  </div>
                </div>


                {/* Pagination – same vibe as Findings */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 px-1 pt-3">
                  <div className="text-xs text-gray-500">
                    Showing{" "}
                    <span className="font-medium text-gray-700">
                      {filtered?.length === 0 ? 0 : pageIndex * pageSize + 1}
                    </span>
                    –
                    <span className="font-medium text-gray-700">
                      {Math.min((pageIndex + 1) * pageSize, filtered?.length)}
                    </span>{" "}
                    of{" "}
                    <span className="font-medium text-gray-700">
                      {filtered?.length}
                    </span>{" "}
                    actions
                  </div>

                  <div className="flex items-center gap-1">
                    {/* Prev arrow */}
                    <button
                      onClick={previousPage}
                      disabled={!canPreviousPage}
                      className="h-8 w-8 rounded-md border border-gray-300 bg-white text-xs text-gray-700
              disabled:opacity-50 hover:bg-gray-50 flex items-center justify-center"
                      aria-label="Previous page"
                    >
                      ‹
                    </button>

                    {/* Page info */}
                    <span className="text-xs text-gray-700 px-2">
                      Page{" "}
                      <span className="font-medium">{pageIndex + 1}</span> of{" "}
                      <span className="font-medium">{totalPages}</span>
                    </span>

                    {/* Next arrow */}
                    <button
                      onClick={nextPage}
                      disabled={!canNextPage}
                      className="h-8 w-8 rounded-md border border-gray-300 bg-white text-xs text-gray-700
              disabled:opacity-50 hover:bg-gray-50 flex items-center justify-center"
                      aria-label="Next page"
                    >
                      ›
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="h-10" />
          </>

        ) : currView === "Kanban" ? (
          <>
            <div className="bg-white border border-gray-200 rounded-2xl shadow-sm mt-6 px-3 md:px-4 xl:px-6 2xl:px-8 py-6">
              <KanBanComponent
                activeDepartmentId={activeDepartmentId}
                activeDepartment={activeDepartment}
                activeComplianceId={activeComplianceId}
                isComp={true}
              />
            </div>

            <div className="h-20" />
          </>
        ) : currView === "Gantt" ? (
          <div className="mt-6">
            {isComp ? (
              <ComplianceGantt activeComplianceId={activeComplianceId} />
            ) : (
              <Gantt
                activeDepartmentId={activeDepartmentId}
                activeDepartment={activeDepartment}
              />
            )}
          </div>
        ) : null}
      </div>

      {/* Action overlay popup lives outside content container */}
      <Popup
        open={isActionOpen}
        contentStyle={{
          overflow: "auto",
          maxHeight: "80vh",
          width: "900px",
          marginTop: "14vh",
        }}
      >
        <ActionOverlay
          closeAction={closeAction}
          risk_id={risk_id}
          action_id={action_id}
        />
      </Popup>
    </div>
  );


};




const mapStateToProps = (state) => {
  ////console.log(state.compliance)
  //console.log(state.department)
  return {
    departments: state.department.departments,
    actions: state.department.actions,
    profile: state.profile.profile,
    actions_stats: state.department.actions_data,
    comp_actions: state.compliance.actions,
    comp_actions_stats: state.compliance.actions_data
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDepartmentsFN: () => dispatch(getDepartments()),
    getDepartmentsActionFN: (department_id) => dispatch(getDepartmentsAction(department_id)),
    getComplianceActionsFN: (c) => dispatch(getComplianceActions(c)),
    getDepartmentsActionDataFN: (department_id) => dispatch(getDepartmentsActionData(department_id)),
    getComplianceActionsDataFN: (c) => dispatch(getComplianceActionsData(c)),
    addActionCommentsFN: (action_id, comments, department_id) => dispatch(addActionComments(action_id, comments, department_id)),
    editActionCommentsFN: (comment_iid, comments, department_id) => dispatch(editActionComments(comment_iid, comments, department_id)),
    editActionProgressFN: (action_id, progress) => dispatch(editActionProgress(action_id, progress)),
    editActionFN: (risk_id, action_id, action) => dispatch(editAction(risk_id, action_id, action)),

  };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(DashboardComponent);
